export function isFeaturedPromotionActive(drink) {
  if (!drink?.is_featured || drink.is_available === false) {
    return false;
  }

  if (!drink.featured_until) {
    return true;
  }

  const until = new Date(`${drink.featured_until}T23:59:59`);
  const today = new Date();
  today.setHours(0, 0, 0, 0);

  return until >= today;
}

/** Fisher–Yates shuffle — new array, original order unchanged. */
export function shuffleFeaturedItems(items = []) {
  const shuffled = [...items];
  for (let i = shuffled.length - 1; i > 0; i -= 1) {
    const j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
}

export function formatFeaturedUntil(dateStr, language = 'en') {
  if (!dateStr) {
    return null;
  }

  const date = new Date(`${dateStr}T12:00:00`);
  if (Number.isNaN(date.getTime())) {
    return null;
  }

  return date.toLocaleDateString(language === 'bg' ? 'bg-BG' : 'en-GB', {
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
}

export function getFeaturedUntilLabel(dateStr, language = 'en') {
  const formatted = formatFeaturedUntil(dateStr, language);
  if (!formatted) {
    return null;
  }

  return language === 'bg'
    ? `Промоция до ${formatted}`
    : `Promoted until ${formatted}`;
}
